// extracted by mini-css-extract-plugin
export var productImage = "_x1-0";